<div
  class="tree-row"
  [class.is-expanded]="row.isExpanded"
  [class.is-inactive]="!row.node.is_active"
  [class.is-focused]="row.isFocused"
  [class.is-dimmed]="row.isDimmed"
  [class.is-selected]="selected"
  [title]="row.isFocused ? 'Click again or press Esc to clear focus' : 'Focus on ' + row.node.name"
  (click)="onRowClick()">
  @if (selectMode) {
    <span class="tree-select" (click)="$event.stopPropagation()">
      @if (selectable) {
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="selected"
          [attr.aria-label]="'Select ' + row.node.name"
          (change)="onCheckboxChange($event)" />
      }
    </span>
  }
  <div class="tree-indent" aria-hidden="true">
    @for (continues of row.guides; track $index) {
      <span
        class="tree-guide"
        [class.has-line]="continues"
        [class.on-path]="row.path?.guides?.[$index]"
        [style.--path-color]="pathColors?.guides?.[$index]"></span>
    }
    <span
      class="tree-elbow"
      [class.is-last]="row.isLastSibling"
      [class.path-up]="row.path?.up"
      [class.path-down]="row.path?.down"
      [class.path-across]="row.path?.across"
      [style.--path-line]="pathColors?.line"
      [style.--path-across]="pathColors?.across"></span>
  </div>

  <span
    class="tree-stem"
    [class.has-stem]="row.isExpanded"
    [class.is-leaf]="!hasReports"
    [class.path-stem]="row.path?.stem"
    [class.path-across]="row.path?.across"
    [style.--path-stem]="pathColors?.stem"
    [style.--path-across]="pathColors?.across">
    @if (hasReports) {
      <button
        type="button"
        class="tree-toggle"
        (click)="onToggleClick($event)"
        [attr.aria-expanded]="row.isExpanded"
        [attr.aria-label]="(row.isExpanded ? 'Collapse ' : 'Expand ') + row.node.name">
        <i class="bi bi-chevron-right"></i>
      </button>
    }
  </span>

  <span class="tree-avatar" [ngClass]="levelClass" aria-hidden="true">{{ initials }}</span>

  <div class="tree-content">
    <div class="tree-person">
      <div class="tree-name">
        <span class="tree-name-text" [title]="row.node.email">{{ row.node.name }}</span>
        @if (!row.node.is_active) {
          <span class="tree-inactive-tag">Inactive</span>
        }
      </div>
    </div>

    <div class="tree-meta">
      <span class="badge app-badge tree-designation" [ngClass]="badgeClass" [title]="row.node.designation">
        <span class="d-none d-lg-inline">{{ row.node.designation }}</span>
        <span class="d-lg-none">{{ shortLabel }}</span>
      </span>

      <span class="tree-employee-number" title="Employee number">#{{ row.node.employee_number }}</span>

      <span class="tree-reporting">
        @if (hasReports) {
          <span class="tree-report-count">
            <i class="bi bi-people"></i>
            {{ row.node.reports.length }} {{ row.node.reports.length === 1 ? 'report' : 'reports' }}
          </span>
        }
        @if (row.hasNoManager) {
          <span class="tree-no-manager" [title]="noManagerLabel + ' assigned yet'">
            <i class="bi bi-person-exclamation"></i>
            {{ noManagerLabel }}
          </span>
        }
      </span>
    </div>
  </div>

  <div class="tree-actions" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </div>
</div>
